// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Color Theme Swatches in HSLA */
  --color-darkest: hsla(189, 68%, 8%, 1);
  --color-darker: hsla(191, 25%, 36%, 1);
  --color-middle: hsla(185, 28%, 65%, 1);
  --color-accent: hsla(39, 33%, 26%, 1);
  --color-light: hsla(0, 0%, 95%, 1);
}

/* Fonts */
.atkinson-hyperlegible-regular {
  font-family: "Atkinson Hyperlegible", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.atkinson-hyperlegible-bold {
  font-family: "Atkinson Hyperlegible", sans-serif;
  font-weight: 700;
  font-style: normal;
}

.atkinson-hyperlegible-regular-italic {
  font-family: "Atkinson Hyperlegible", sans-serif;
  font-weight: 400;
  font-style: italic;
}

.atkinson-hyperlegible-bold-italic {
  font-family: "Atkinson Hyperlegible", sans-serif;
  font-weight: 700;
  font-style: italic;
}

/* POSITIONING */
/* get rid of default styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root {
  font-family: "Atkinson Hyperlegible", sans-serif;
}

/* positioning */
body {
  display: grid;
  min-height: 100vh;
  grid-template-areas:
    "header"
    "container"
    "footer";
  grid-template-rows: auto 15fr auto;
}

body {
  background: var(--color-light);
}

#container {
  padding: 1% 10% 0 5%;
  grid-area: container;
}

button {
  box-sizing: border-box;
  padding: 1vw;
  font-size: 1.2rem;
  text-wrap: nowrap;
}

/* shared between all #containers */
.main-heading {
  grid-area: heading;
  font-size: 2rem;
  padding: 1%;
}
`, "",{"version":3,"sources":["webpack://./src/static/css/main.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA,UAAU;AACV;EACE,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gDAAgD;AAClD;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,iBAAiB;EACjB;;;YAGU;EACV,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb","sourcesContent":[":root {\n  /* Color Theme Swatches in HSLA */\n  --color-darkest: hsla(189, 68%, 8%, 1);\n  --color-darker: hsla(191, 25%, 36%, 1);\n  --color-middle: hsla(185, 28%, 65%, 1);\n  --color-accent: hsla(39, 33%, 26%, 1);\n  --color-light: hsla(0, 0%, 95%, 1);\n}\n\n/* Fonts */\n.atkinson-hyperlegible-regular {\n  font-family: \"Atkinson Hyperlegible\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n}\n\n.atkinson-hyperlegible-bold {\n  font-family: \"Atkinson Hyperlegible\", sans-serif;\n  font-weight: 700;\n  font-style: normal;\n}\n\n.atkinson-hyperlegible-regular-italic {\n  font-family: \"Atkinson Hyperlegible\", sans-serif;\n  font-weight: 400;\n  font-style: italic;\n}\n\n.atkinson-hyperlegible-bold-italic {\n  font-family: \"Atkinson Hyperlegible\", sans-serif;\n  font-weight: 700;\n  font-style: italic;\n}\n\n/* POSITIONING */\n/* get rid of default styles */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  font-family: \"Atkinson Hyperlegible\", sans-serif;\n}\n\n/* positioning */\nbody {\n  display: grid;\n  min-height: 100vh;\n  grid-template-areas:\n    \"header\"\n    \"container\"\n    \"footer\";\n  grid-template-rows: auto 15fr auto;\n}\n\nbody {\n  background: var(--color-light);\n}\n\n#container {\n  padding: 1% 10% 0 5%;\n  grid-area: container;\n}\n\nbutton {\n  box-sizing: border-box;\n  padding: 1vw;\n  font-size: 1.2rem;\n  text-wrap: nowrap;\n}\n\n/* shared between all #containers */\n.main-heading {\n  grid-area: heading;\n  font-size: 2rem;\n  padding: 1%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
